import mutations from "./mutations";
import actions from "./actions";

const state = {
  references: [],
  currentReference: null,
  isFetchingCurrentReference: false,
  isFetchingReferences: false,
  currentUserReferences: [],
  isFetchingUserReferences: false
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
